// Per-route page titles for GA4 `page_view` + the browser tab. `index.html`
// ships a static `<title>Polymyth</title>`, so without this every page_view
// carried the same blank-ish title and the tab never updated.
//
// Dependency-free on purpose (no analytics/firebase imports) so it stays
// trivially unit-testable.
const TITLE_BY_PATH: Record<string, string> = {
  '/': 'Polymyth',
  '/about': 'About',
  '/faq': 'FAQ',
  '/multiplayer': 'Playing with Friends',
  '/tos': 'Terms of Service',
  '/privacy': 'Privacy Policy',
  '/delete-account': 'Delete Account',
  '/login': 'Log In',
  '/signup': 'Sign Up',
  '/reset-password': 'Reset Password',
  '/verify-email': 'Verify Email',
  '/get-the-app': 'Get the App',
  '/deck': 'Investor Deck',
  '/partnership': 'Partnership',
  '/dashboard': 'Dashboard',
  '/lobby': 'Lobby',
  '/buy-tokens': 'Buy PMT',
  '/admin': 'Admin',
  '/odyssey-test': 'Odyssey Test',
};

/** The page title for a pathname; falls back to the brand for unknown routes. */
export function titleForPath(pathname: string): string {
  const exact = TITLE_BY_PATH[pathname];
  if (exact) return exact;
  // Dynamic route: /play/:sessionId
  if (pathname.startsWith('/play/')) return 'Game';
  return 'Polymyth';
}
